document.addEventListener("DOMContentLoaded", (event) => {

	// //------------ Change placeholder on window size ------------
	// function updatePlaceholder() {
	// 	const input = document.getElementById("searchInput");
	// 	if (window.innerWidth <= 991) { 
	// 	input.placeholder = "Search"; // mobile
	// 	} else {
	// 	input.placeholder = "Search for..."; // desktop
	// 	}
	// }
	// updatePlaceholder();
	// window.addEventListener("resize", updatePlaceholder);

	//------------ Accordians ------------
	const accordions = document.querySelectorAll("[data-accordion-title]");
	accordions.forEach((accordion) => {
		accordion.addEventListener("click", (e) => {
			e.stopPropagation();

			const isActive = accordion.classList.contains("active");
			const group = accordion.closest("[data-accordion]"); // only this group

			// Close siblings in same group
			group.querySelectorAll(":scope > [data-accordion-title]").forEach((item) => {
				item.classList.remove("active");
				if (item.nextElementSibling) {
					item.nextElementSibling.style.maxHeight = null;
				}
			});

			group.parentElement.querySelectorAll("[data-accordion-title]").forEach((item) => {
				item.classList.remove("active");
				if (item.nextElementSibling) {
					item.nextElementSibling.style.maxHeight = null;
				}
			});

			// Toggle clicked accordion
			if (!isActive) {
				accordion.classList.add("active");
				if (accordion.nextElementSibling) {
					accordion.nextElementSibling.style.maxHeight =
					accordion.nextElementSibling.scrollHeight + "px";
				}
			}
		});
	});
	

	//------------ Onscroll Header Sticky ------------
	window.addEventListener("scroll", function () {
		if (window.scrollY > 100) {
			document.querySelectorAll("body.index-template .site-header").forEach(el => {
			el.classList.add("sticky");
			});
		} else {
			document.querySelectorAll("body.index-template .site-header").forEach(el => {
			el.classList.remove("sticky");
			});
		}
	});


	//------------ Mobile Menu Open ------------
	document.body.addEventListener("click", function (e) {
		if (window.innerWidth < 992) {
			const btn = e.target.closest(".header-content .menu-btn");			
			if (btn) {
				e.preventDefault(); 
				btn.classList.toggle("active"); 
				const nextEl = btn.nextElementSibling;
				if (nextEl && nextEl.classList.contains("main-menu") && nextEl.classList.contains("mobile-menu") ) {
					nextEl.classList.toggle("open");
				}
				document.body.classList.toggle("overflow-hidden");
				document.querySelector(".overlay").classList.toggle("is-open");
			}

			if(e.target.matches('.mobile-menu.open')){
				document.body.classList.toggle("overflow-hidden");
				document.querySelector('.overlay')?.classList.remove('is-open');
				document.querySelector('.main-menu.mobile-menu')?.classList.remove('open');
				document.querySelector('.head-left .menu-btn')?.classList.remove('active');
			}
		}
	});
	
	//------------ Open/Close search bar ------------
	document.body.addEventListener("click", function (e) {
		if (e.target.closest(".right-icon .search-btn")) {
			e.preventDefault();
			document.querySelector(".search-bar").classList.add("open");
			document.querySelector(".overlay").classList.add("is-open");
		}
	});
	document.body.addEventListener("click", function (e) {
		if (e.target.closest(".search-bar .seach-close") || e.target.closest(".overlay")) {
			e.preventDefault();
			document.querySelector(".search-bar").classList.remove("open");
			document.querySelector(".overlay").classList.remove("is-open");
		}
	});


	//------------ Header Height ------------
	function headerspace() {
		if (window.innerWidth < 992) {
			const header = document.querySelector(".site-header");
			const headerHeight = header ? header.offsetHeight : 0;

			document.querySelectorAll(".main-menu.mobile-menu").forEach(el => {
				el.style.top = headerHeight + "px";
			});
		} else {
			document.querySelectorAll(".main-menu.mobile-menu").forEach(el => {
      			el.style.top = "";
      		});
		}
		// for PDP slider
		if (window.innerWidth > 992) {
			const header = document.querySelector(".site-header");
			const headerHeight = header ? header.offsetHeight : 0;

			document.querySelectorAll(".product-carousel-wrapper").forEach(el => {
				el.style.top = headerHeight + "px";
			});
		} else {
			document.querySelectorAll(".product-carousel-wrapper").forEach(el => {
				el.style.top = "";
			});
		}
		// for Search Bar
		const header = document.querySelector(".site-header");
		const headerHeight = header ? header.offsetHeight : 0;

		document.querySelectorAll(".search-bar").forEach(el => {
			el.style.top = headerHeight + "px";
		});
		document.querySelectorAll(".hero-section .section-content").forEach(el => {
			el.style.marginTop = headerHeight + "px";
			el.style.height = `calc(100% - ${headerHeight}px)`;
		});
		document.querySelectorAll(".cart-total-wpr").forEach(el => {
			el.style.top = (headerHeight + 30) + "px";
		});
		document.querySelectorAll(".filter-sort-content-wrapper").forEach(el => {
			el.style.top = headerHeight + "px";
		});
		document.querySelectorAll(".mega-menu").forEach(el => {
			el.style.setProperty('--header-space', headerHeight + "px");			
		});
	}
	headerspace();
	["resize", "load", "scroll", "orientationchange"].forEach(event => {
		window.addEventListener(event, headerspace);
	});


	//------------ Menu Carousel [Mobile Header] ------------
	var megamenu_slider = new Swiper(".megamenu-slider", {
		loop: false,
		spaceBetween: 16,
		slidesPerView: 4,
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
		// navigation: {
		// 	nextEl: ".swiper-button-next",
		// 	prevEl: ".swiper-button-prev",
		// },
		// autoplay: {
		// 	delay: 2500,
		// 	disableOnInteraction: false,
		// },
		breakpoints: {
			1281: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 3,
			},
			320: {
				slidesPerView: 2,
			},
		},
	});


	//------------ Open Size Dropdown [Product Card] ------------
	document.body.addEventListener("click", function (e) {
		const btn = e.target.closest(".product-card .size-cart-btn .card-prod-option > span");
		if (btn) {
			e.preventDefault();

			document.querySelectorAll(".product-card .size-cart-btn .card-prod-option > span.active").forEach(span => {
				if (span !== btn) {
					span.classList.remove("active");
					const dropdown = span.nextElementSibling;
					if (dropdown && dropdown.classList.contains("size-dropdown")) {
						dropdown.classList.remove("open");
					}
				}
			});

			btn.classList.toggle("active");
			const nextEl = btn.nextElementSibling;
			if (nextEl && nextEl.classList.contains("size-dropdown")) {
				nextEl.classList.toggle("open");
			}
		}
		
		if (!e.target.closest(".size-cart-btn")) {
			document.querySelectorAll(".product-card .size-cart-btn .card-prod-option > span.active").forEach(span => {
				span.classList.remove("active");
				const dropdown = span.nextElementSibling;
				if (dropdown && dropdown.classList.contains("size-dropdown")) {
					dropdown.classList.remove("open");
				}
			});
		}

		if(e.target.matches('.drawer__close')){ 
			e.preventDefault();
			document.querySelector("cart-drawer").classList.remove("is-open");
			document.querySelector(".overlay").classList.remove("is-open");
			document.body.classList.remove("overflow-hidden");
		}

		if(e.target.closest('.filter-btn') || e.target.closest('.inner-filter-sort-content .filter-close')){	
			e.preventDefault();		
			document.querySelector('.inner-filter-sort-content').classList.toggle('open');
			document.querySelector(".overlay").classList.toggle("is-open");
			document.body.classList.toggle("overflow-hidden");
		}

		//  outside click the sort wrapper
		let sortFilter = document.querySelector('.sort-wrapper')
		if (sortFilter && !sortFilter.contains(e.target)) {
			sortFilter.querySelector('.sort-btn').classList.remove('active');
			sortFilter.querySelector('.sort-dropdown').style.maxHeight = null; 
		}
		if (e.target.matches('.inner-filter-sort-content')) {
			document.querySelector('.inner-filter-sort-content')?.classList.remove('open');
			document.querySelector('.overlay')?.classList.remove('is-open');
			document.body.classList.toggle("overflow-hidden");
		}
		if(e.target.matches('.filter-apply-btn button')){
			document.querySelector('.inner-filter-sort-content')?.classList.remove('open');
			document.querySelector('.overlay')?.classList.remove('is-open');
			document.body.classList.toggle("overflow-hidden");
		}
	});

	document.body.addEventListener("change", function (e) {

		/* Product card - update variant id based on options  */
		const li = e.target.closest(".card-prod-option li");
		if(li){
			const ul = li.closest("ul");
			if (!ul) return;
		
			ul.querySelectorAll("li").forEach((item) => item.classList.remove("selected"));
			li.classList.add("selected");
			
			const value = li.dataset.value;
			const selected_li_value = li.querySelector('label').textContent.trim();
			let span = li.closest('.card-prod-option').querySelector('.size-wrapper span');
			if(!span.querySelector('svg')){
				var priceSpan = li.closest('.product-card').querySelector('p.card-product-price  span');		
			}	
				
			const btnAddtoCart = li.closest('.size-cart-btn').querySelector('.product-form__submit');
			const jsonData = li.closest('.product-card').querySelector('#ProductVariantJson').textContent;
			const variants = JSON.parse(jsonData);
			const options = li.closest('.size-cart-btn, free-shipping-cart-btn').querySelectorAll('.card-prod-option ul li.selected');
			const selectedOptionValues = Array.from(options).map(item => item.dataset.value);
			
			const currentVariant = variants.find(variant =>
				variant.options.every((opt, i) => opt === selectedOptionValues[i])
			);			
			
			if(currentVariant){		
						
				if(currentVariant.available){
					const variantInput = li.closest('.size-cart-btn, free-shipping-cart-btn').querySelector('input[name="id"]');
					variantInput.value = currentVariant.id;
					btnAddtoCart.removeAttribute('disabled');
					if(!span.querySelector('svg')) priceSpan.textContent = Shopify.formatMoney(currentVariant.price, window.money_format);
				}else{
					btnAddtoCart.setAttribute('disabled', true);	
					if(!span.querySelector('svg')) priceSpan.textContent = 'Sold Out';
				}

				const priceEl = li.closest('.product-card').querySelector('.price__sale .price-item--sale');
				const cpriceEl = li.closest('.product-card').querySelector('.price__sale .price-item--regular');
				if (priceEl) {
					priceEl.innerHTML = Shopify.formatMoney(currentVariant.price, window.money_format);				
				}
				
				if (currentVariant.compare_at_price && cpriceEl) {
					cpriceEl.innerHTML = Shopify.formatMoney(currentVariant.compare_at_price, window.money_format);
				}
				
				if(span.querySelector('svg')){
					console.log('btnAddtoCart', btnAddtoCart);
					btnAddtoCart.click();
				}else{
					span.textContent = selected_li_value;
				}
			}else{				
				btnAddtoCart.setAttribute('disabled', true);
			}
			span.dispatchEvent(new Event('click', { bubbles: true }));
		}

	});


	//------------ Product Slider [Product Card] ------------
	var product_carousel_thumb = new Swiper(".product-carousel-thumb", {
		loop: false,
		spaceBetween: 16,
		slidesPerView: 8,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			1281: {slidesPerView: 8},
			1025: {slidesPerView: 7},
			641: {slidesPerView: 6},
			481: {slidesPerView: 5},
			319: {slidesPerView: 4},
		},
	});
	var product_carousel = new Swiper(".product-carousel", {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 16,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
		},
		thumbs: {
			swiper: product_carousel_thumb,
		},
		on: {
			slideChange: function (swiper) {
				pauseAllMedia();
				const activeSlide = swiper.slides[swiper.activeIndex];
				playMediaInSlide(activeSlide);
			}
		}
	});

	var hero_carousel = new Swiper(".hero-swiper",{
		loop: true,
		slidesPerView: 1,
		on: {
			slideChange: function (swiper) {
				pauseAllMedia();
				const activeSlide = swiper.slides[swiper.activeIndex];
				playMediaInSlide(activeSlide);
			}
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	function pauseAllMedia() {
		document.querySelectorAll('.js-youtube').forEach((video) => {
			video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		});
		document.querySelectorAll('.js-vimeo').forEach((video) => {
			video.contentWindow.postMessage('{"method":"pause"}', '*');
		});
		document.querySelectorAll('video').forEach((video) => video.pause());
		document.querySelectorAll('product-model').forEach((model) => {
			if (model.modelViewerUI) model.modelViewerUI.pause();
		});
	}

	function playMediaInSlide(slide) {
		if (!slide) return;
		
		const youtubeVideo = slide.querySelector('.js-youtube');
		if (youtubeVideo) {
			youtubeVideo.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
			youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
		}
		
		const vimeoVideo = slide.querySelector('.js-vimeo');
		if (vimeoVideo) {
			vimeoVideo.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
			vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
		}
		
		const nativeVideo = slide.querySelector('video');
		if (nativeVideo) {
			nativeVideo.play().catch(err => console.log('Auto-play prevented:', err));
		}
		
		const model = slide.querySelector('product-model');
		if (model && model.modelViewerUI) {
			model.modelViewerUI.play();
		}
	}
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.btnMinus = null;
    this.btnPlus = null;
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="number"]');
    this.btnMinus = this.querySelector('.qty-minus-btn');
    this.btnPlus = this.querySelector('.qty-plus-btn');

    // Set default min value
    if (this.input) {
      this.input.setAttribute('min', '1');
    }

    // Event listeners
    if (this.btnMinus) {
      this.btnMinus.addEventListener('click', this.decrease.bind(this));
    }

    if (this.btnPlus) {
      this.btnPlus.addEventListener('click', this.increase.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('input', this.validateMin.bind(this));
    }
  }

  decrease(e) {
    e.preventDefault();
    const current = parseInt(this.input.value) || 1;
    if (current > 1) {
      this.input.value = current - 1;
      this.triggerChange();
    }
  }

  increase(e) {
    e.preventDefault();
    const current = parseInt(this.input.value) || 1;
    this.input.value = current + 1;
    this.triggerChange();
  }

  validateMin() {
    if (parseInt(this.input.value) < 1 || isNaN(this.input.value)) {
      this.input.value = 1;
      this.triggerChange();
    }
  }

  triggerChange() {
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// Register the custom element
customElements.define('quantity-input', QuantityInput);